import { parsePermissions, hasPermission } from '@/utils/permission';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};

  // 解析用户权限
  const userPermissions = currentUser?.modules ? parsePermissions(currentUser.modules) : {};

  // 权限检查函数
  const checkPermission = (permission: string): boolean => {
    return hasPermission(userPermissions, permission);
  };

  return {
    // 鉴定管理权限

    'appraisal.category.view': checkPermission('appraisal.category.view'),
    'appraisal.category.add': checkPermission('appraisal.category.add'),
    'appraisal.category.edit': checkPermission('appraisal.category.edit'),
    'appraisal.category.delete': checkPermission('appraisal.category.delete'),
    'appraisal.identity.view': checkPermission('appraisal.identity.view'),
    'appraisal.identity.add': checkPermission('appraisal.identity.add'),
    'appraisal.identity.edit': checkPermission('appraisal.identity.edit'),
    'appraisal.identity.delete': checkPermission('appraisal.identity.delete'),
    'appraisal.identityHistory.view': checkPermission('appraisal.identityHistory.view'),
    'appraisal.identityHistory.start': checkPermission('appraisal.identityHistory.start'),
    'appraisal.guide.view': checkPermission('appraisal.guide.view'),
    'appraisal.guide.delete': checkPermission('appraisal.guide.delete'),
    'appraisal.guide.add': checkPermission('appraisal.guide.add'),
    'appraisal.guide.edit': checkPermission('appraisal.guide.edit'),
    'appraisal.reservation.view': checkPermission('appraisal.reservation.view'),
    'appraisal.reservation.edit': checkPermission('appraisal.reservation.edit'),
    'appraisal.brand.view': checkPermission('appraisal.brand.view'),
    'appraisal.brand.add': checkPermission('appraisal.brand.add'),
    'appraisal.brand.edit': checkPermission('appraisal.brand.edit'),
    'appraisal.brand.delete': checkPermission('appraisal.brand.delete'),

    // 用户管理权限
    'userManager.list.view': checkPermission('userManager.list.view'),
    'userManager.list.add': checkPermission('userManager.list.add'),
    'userManager.list.edit': checkPermission('userManager.list.edit'),
    'userManager.list.delete': checkPermission('userManager.list.delete'),
    'userManager.transaction.view': checkPermission('userManager.transaction.view'),
    'userManager.transaction.add': checkPermission('userManager.transaction.add'),
    'userManager.transaction.edit': checkPermission('userManager.transaction.edit'),
    'userManager.transaction.delete': checkPermission('userManager.transaction.delete'),
    'userManager.appoint.view': checkPermission('userManager.appoint.view'),
    'userManager.appoint.audit': checkPermission('userManager.appoint.audit'),
    'userManager.auth.view': checkPermission('userManager.auth.view'),
    'userManager.auth.audit': checkPermission('userManager.auth.audit'),
    'userManager.address.view': checkPermission('userManager.address.view'),
    'userManager.comment.view': checkPermission('userManager.comment.view'),
    'userManager.withdraw.view': checkPermission('userManager.withdraw.view'),
    'userManager.withdraw.audit': checkPermission('userManager.withdraw.audit'),
    'userManager.appraiser.view': checkPermission('userManager.appraiser.view'),
    'userManager.appraiser.edit': checkPermission('userManager.appraiser.edit'),

    // 社区管理权限
    'community.topic.view': checkPermission('community.topic.view'),
    'community.topic.add': checkPermission('community.topic.add'),
    'community.topic.edit': checkPermission('community.topic.edit'),
    'community.topic.delete': checkPermission('community.topic.delete'),

    // 商城管理权限
    'mall.product.view': checkPermission('mall.product.view'),
    'mall.product.add': checkPermission('mall.product.add'),
    'mall.product.edit': checkPermission('mall.product.edit'),
    'mall.product.delete': checkPermission('mall.product.delete'),
    'mall.category.view': checkPermission('mall.category.view'),
    'mall.category.add': checkPermission('mall.category.add'),
    'mall.category.edit': checkPermission('mall.category.edit'),
    'mall.category.delete': checkPermission('mall.category.delete'),
    'mall.order.view': checkPermission('mall.order.view'),
    'mall.order.add': checkPermission('mall.order.add'),
    'mall.order.edit': checkPermission('mall.order.edit'),
    'mall.order.delete': checkPermission('mall.order.delete'),
    'mall.product.audit': checkPermission('mall.product.audit'),
    'mall.orderComment.view': checkPermission('mall.orderComment.view'),
    'mall.coupon.view': checkPermission('mall.coupon.view'),
    'mall.coupon.add': checkPermission('mall.coupon.add'),
    'mall.couponRedemption.view': checkPermission('mall.couponRedemption.view'),
    'mall.couponUse.view': checkPermission('mall.couponUse.view'),

    // 系统管理权限
    'system.manager.view': checkPermission('system.manager.view'),
    'system.manager.add': checkPermission('system.manager.add'),
    'system.manager.edit': checkPermission('system.manager.edit'),
    'system.manager.delete': checkPermission('system.manager.delete'),
    'system.role.view': checkPermission('system.role.view'),
    'system.role.add': checkPermission('system.role.add'),
    'system.role.edit': checkPermission('system.role.edit'),
    'system.role.delete': checkPermission('system.role.delete'),
    'system.permissionLog.view': checkPermission('system.permissionLog.view'),

    // 兼容旧格式权限
    'user.view': checkPermission('userManager.list.view'),
    'admin.view': checkPermission('system.manager.view'),
    'appraisal.view': checkPermission('appraisal.category.view'),
  };
}
